import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import AppLayout from '../layout/AppLayout';
import { routes } from './routes';

const routesFromElements = createRoutesFromElements(
    <Route path={routes.DEFAULT} element={<AppLayout />}>
        <Route path='*' element={<Navigate to={routes.DEFAULT} />} />
    </Route>
);

export const router = createHashRouter(routesFromElements);
